<template>
<div class="page-container">
		 
	  <div class="content">
	  	   <div class="content-main-1">
		         <div class="main-box-1">
		   		      <ul :class="'box-list-1 '+code">
				           <!--li class="select-box" @click="showCategory('gtype')">{{cateName1}}<span class="icon-1"><img src="../../assets/img/btn-arrow.png" width=15 height=15></span></li-->
				      	   <li class="select-box" style='width:500px;' @click="showCategory('comp')">{{cateName2}}<span class="icon-1"><img src="../../assets/img/btn-arrow.png" width=15 height=15></span></li>
						   <li  class="all-button"><md-button class="md-raised md-primary" @click="allSolve()" type="button">모든 문제 풀기</md-button></li>
						   <li class="box-img">
				 	  		<img src="../../assets/img/btn-joi.png" width=19 height=19  @click="searchLoad('/problem/search')">
						   </li>
				 	  </ul>
					  
				 </div>
		   </div>
		   <div class="content-main-2">

				  <div class="box-card" v-for="data,index in dataList">
				        <ul class="box-car-list-1">
						     <li><div class="box-btn-img"><img :src="$VARS.url+data.img" width=30 height=30 v-if="data.img"><i v-else class="far fa-image"></i></div></li>
							 <li><div class="box-text">{{data.name}}<br><span class="box-text-1">{{data.subject}}</span></div></li>
							 <li v-if="data.result">
								<div class="box-small result" @click="goDirectView(data.no)">상세보기</div>
							 </li>
							 <li v-else>
								<div class="box-small" @click="goView(data.no,index)">풀기<span class="radius" v-if="code=='me' && data.temp"></span></div>
							 </li>

						</ul>
						<ul class="box-car-list-2"   v-if="data.result">
						      <li>점수<span class="box-time">{{data.score}}점</span></li>
							  <li><span class="box-radius" :style="{'width':data.scorePer+'%'}"></span></li>
						</ul>
						<ul class="box-car-list-2" v-else-if="code=='ai' && !data.result" style='display:none;'>
						      <li><span class="text">남은 시간</span><span class="box-time">50분</span></li>
							  <li><span class="box-radius"></span></li>
						</ul>
				  </div>
				  
				
		   </div>
		</div>
		<div class="screenLayout" v-if="screenView">
			<div class="content-wrapper">
				<div class="content-box">
					<span @click="screenView=false"><i class="fa fa-times"></i></span>
					<ul style='max-height:300px;overflow-y:auto;'>
						<li style='cursor:pointer;' v-for="item,index in categorys" @click="searchList(index)">{{item.name}}</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="screenLayout" v-if="searchScreenView">
			<div class="content-wrapper">
				<div class="content-box" style='width:780px;padding:0;border-radius:0;'>
					<router-view></router-view>
				</div>
			</div>
		</div>
  </div>
</template>

<script>

export default {
	name: 'ProblemList',
	props:["code"],
	watch: {
		code(val) {
			this.getData();
		},
		'$route' (to, from) {
			if(from.name == 'ProblemSearch') {
				this.searchScreenView = false;
				if(sessionStorage.getItem('compNo')) {
					this.cate1 = '';
					this.cateName1 = '1차 카테고리';
					
					this.cate2 = sessionStorage.getItem('compNo');
					this.cateName2 = sessionStorage.getItem('compName');
			
					this.getData();
					sessionStorage.setItem('compNo','');
					sessionStorage.setItem('compName','');
				}
			}
		}

	},
	data() {
		return {
			dataList:[],
			companyList:{},
			gtypeList:{},
			categorys:[],
			sendFlag:false,
			screenView:false,
			searchScreenView:false,
			ctype:'',
			cate1:'',
			cate2:'',
			timeInterval:{},
			cateName1:'1차 카테고리',
			cateName2:'2차 카테고리',
			aiSolveResults:{},
			
		}
	},
	created() {
		var intro = localStorage.getItem('intro')
	    if(intro=='used' && sessionStorage.getItem('memberkey')) {
	 		this.getData();
		}
	},
    methods: {
		searchLoad(url) {
			this.$router.push({path:url});
			this.searchScreenView=true;
		},
		getData() {	
			var obj = this;
			this.$form.sendPost({gtype:this.cate1,cno:this.cate2,cmd:this.code},'problem/dataList',function(resp) {
				if(!resp.myAI) {
					var cate = (obj.cate1)?obj.cate1:resp.myGtype; 
					obj.$router.push({path:'/member/myAi/'+cate})
					return;
				}
		
				obj.companyList = resp.companyList;
				obj.gtypeList = resp.gtypeList;
				obj.dataList = resp.dataList.datas;
			},'multi');
		},	
		goDirectView(no) {
			this.$router.push({path:'/problem/view/'+this.code+'/'+no});
			
		},
		goView(no,index) {
			if(this.code=='me') {
				this.$router.push({path:'/problem/view/'+this.code+'/'+no});
			} else {
				if(this.timeInterval[index]) {
					if(this.timeInterval[index]=='break') {
						this.$router.push({path:'/problem/view/'+this.code+'/'+no});
					}
					return;
				}

				var $el = $('.content-main-2 .box-card').eq(index).find('.box-car-list-2');
				var $elTop = $('.content-main-2 .box-card').eq(index).find('.box-car-list-1');
				$el.show();
				var total = 2000; 
				var obj = this;
				var time = 60;
				var width = 0;

				obj.aiSolveResults[index] = {mode:''};	
				this.timeInterval[index] = setInterval(function() {
					if(total>0) {
						total = total - 100; 
						time = time - 3;
						width = width + 5;
						$el.find('.box-time').text(time+'분');
						$el.find('.box-radius').css('width',width+'%');
					} else {
						
						clearInterval(obj.timeInterval[index]);
						var resp = obj.aiSolveResults[index];
						if(resp.result=='succ') {
							$el.find('.text').text('점수');
							$el.find('.box-time').text(resp.score+'점');
							$el.find('.box-radius').css('width',resp.per+'%');
							$elTop.find('.box-small').html('상세보기').addClass('result');
							obj.timeInterval[index] = 'break';
						} else {
							obj.aiSolveResults[index].mode = 'end';	
						}
					}
						
				},100);
				this.$form.sendPost({no:no},'/problemProc/aiRegistTest',function(resp) {
						if(resp.result == 'succ') {
							
							if(obj.aiSolveResults[index].mode =='end') {
							
								$el.find('.text').text('점수');
								$el.find('.box-time').text(resp.score+'점');
								$el.find('.box-radius').css('width',resp.per+'%');
								$elTop.find('.box-small').html('상세보기').addClass('result');
								obj.timeInterval[index] = 'break';
							} else {
								obj.aiSolveResults[index] = resp;
							}
						}
				},'multi');
				
			}
		},
		allSolve() {
			var obj = this;
		    if(this.sendFlag)return;
			this.sendFlag = true;
			$('.content-main-2 .box-card').each(function(k) {
				if(obj.dataList[k].result) {
					return;
				}
				if(obj.timeInterval[k])return;
				var $el = $(this).find('.box-car-list-2');
				var $elTop = $(this).find('.box-car-list-1');
				$el.show();
				
				var total = 6000; 
				var time = 180;
				var width = 0;
				obj.aiSolveResults[k] = {mode:''};	
				obj.timeInterval[k] = setInterval(function() {
					if(total>0) {
						total = total - 100; 
						time = time - 3;
						width = width + 1.7;
						if(width>100)width=100;
						$el.find('.box-time').text(time+'분');
						$el.find('.box-radius').css('width',width+'%');
					} else {
						clearInterval(obj.timeInterval[k]);
						var resp = obj.aiSolveResults[k];
						if(resp.result=='succ') {
							console.log('sd');
							$el.find('.text').text('점수');
							$el.find('.box-time').text(resp.score+'점');
							$el.find('.box-radius').css('width',resp.per+'%');
							$elTop.find('.box-small').html('상세보기').addClass('result');
							obj.timeInterval[k] = 'break';
							obj.sendFlag = false;
					
						} else {
							obj.aiSolveResults[k].mode = 'end';	
						}
					}
						
				},100);
			});
			
			this.$form.sendPost({},'/problemProc/aiAllRegistTest',function(response) {
					for(var i in response) {
						var resp = response[i];
						if(resp.result == 'succ') {
							if(obj.aiSolveResults[i].mode =='end') {
								
								
								var $el = $('.content-main-2 .box-card').eq(i).find('.box-car-list-2');
								var $elTop = $('.content-main-2 .box-card').eq(i).find('.box-car-list-1');

								$el.find('.text').text('점수');
								$el.find('.box-time').text(resp.score+'점');
								$el.find('.box-radius').css('width',resp.per+'%');
								$elTop.find('.box-small').html('상세보기').addClass('result');
								obj.timeInterval[i] = 'break';
								obj.sendFlag = false;
					
							} else {
								obj.aiSolveResults[i] = resp;
							}
						}
					}
			},'multi');

		},
		goPage(url) {
			this.$router.push({path:url});
		},
		showCategory(ctype) {
			this.ctype = ctype;
			this.categorys=[];
			var item = {no:'',name:'전체보기'}
			this.categorys.push(item);		
			switch(ctype) {
				case 'gtype':
					for(var key in this.gtypeList) {	
						var item = {no:key,name:this.gtypeList[key]}
						this.categorys.push(item);		
					}
				break;
				case 'comp':
					var item = {no:'me',name:'내가 선택한 업체만 보기'}
					this.categorys.push(item);		
					for(var key in this.companyList) {	
						var item = {no:key,name:this.companyList[key].name}
						this.categorys.push(item);		
					}
				break;
			}
			this.screenView = true;
		
		},
		searchList(index) {
			var item = this.categorys[index];
			switch(this.ctype) {
				case 'gtype':
					this.cate1 = item.no;
					this.cateName1 = item.name;
				break;
				case 'comp':
					this.cate2 = item.no;
					this.cateName2 = item.name;
				break;
			}
			this.getData();
			this.screenView = false;
		},
		
    },
	mounted() {
		
			
	},	
	updated() {
		
	  
	}

}
</script>


<style lang="scss" scoped>
.page-container      {
          width:100%;
		  min-height:calc(100vh);
		  background-color:#E6E8F4;
		  .content		{
		  			 width:830px;
					 height:auto;
					 margin:auto;
					 padding:160px 0 0 0;
					 background-color:#E6E8F4;
					 .content-main-1		{
					 			
								width:100%;
								padding:12px 0;
								.main-box-1		  {
										  display:flex;
										  .box-list-1		{
										  		display:flex;
												width:100%;
												li.select-box       {
												     width:250px;
													 height:40px;
													 line-height:38px;
													 padding-left:20px;
													 border:1px solid #A8A8A8;
													 border-radius:20px;
													 font-family: 'Nanum Gothic', sans-serif;
					                                 font-size:14px;
					                                 color:#000;
													 position:relative;
													 background-color:#fff;
													 margin-right:15px;
													 cursor:pointer;
													 .icon-1		{
													 		display:inline-block;
															position:absolute;
															right:17px;
															top:-1px;
															
													 }
												}
												li.all-button {
													width:250px;
													.md-button {
														padding:0;
														margin:0;
														width:100%;
														min-height:38px;
														height:38px;
										  				border-radius:20px;
														background-color:#3D79FE;
													}

												}
												li.box-img {
													width:145px;
													text-align:right;
													padding-top:12px;
													cursor:pointer;
												}

										  }
										  .box-list-1.me		{
												li.select-box       {
												     width:400px;
												}
												li.all-button {
													display:none;

												}
												li.box-img {
													width:30px;
													text-align:right;
													padding-top:12px;
													cursor:pointer;
												}

										  }
								}
					 }
					 .content-main-2       {
								   width:100%;
								   padding:0;
								   display:flex;
								   flex-wrap:wrap;
								   .box-card	  {
								   		  width:400px;
										  background-color:#fff;
										  padding:18px 10px 18px 20px;
										  margin-top:10px;
										  &:nth-child(odd)     {
												margin-right:30px;
										  }
										  .box-car-list-1      {
										           display:flex;
												   width:100%;
												   position:relative;
												   li			   {
												         .box-btn-img     {
														           width:55px;
																   height:55px;
																   line-height:50px;
																   border-radius:50%;
																   border:1px solid #E7E7E7;
																   text-align:center;
																   overflow:hidden;
																   img {
																	 width:100%;
																	 min-height:55px;
																   }
														 }
														 .box-text       {
														 		   margin-left:20px;
																   font-family: 'Nanum Gothic', sans-serif;
																   font-size:15px;
																   color:#000;
																   font-weight:bold;
																   padding-top:9px;
																   line-height:18px;
																   .box-text-1       {
																   			display:inline-block;
																			color:#9A9A9A;
																			font-size:13px;
																			font-weight:normal;
																   }
														 }
														 .box-small       {
														 			position:absolute;
																	right:0;
																	cursor:pointer;
																	top:10px;
																	height:30px;
																	width:60px;
																	text-align:center;
																	border-radius:15px;
																	background-color:#3D79FE;
																	color:#fff;
																	padding-top:5px;
																	font-size:12px;
																	.radius        {
																			  display:inline-block;
																			  width:13px;
																			  height:13px;
																			  border-radius:50%;
																			  border:1px solid #fff;
																			  background:#70CD03;
																			  position:absolute;
																			  margin-left:7px;
																			  top:-2px;
																	}
														 }
														 .box-small.result {
																background-color:#fff;
																color:#555;
																border:solid 1px #ccc;	
														 }
												   }
													  
										  }
										  .box-car-list-2       {
										  			  width:100%;
													  padding-top:7px;
													  li			{
													  		  font-family: 'Nanum Gothic', sans-serif;
															  font-size:12px;
															  color:#9F9F9F;
															  position:relative;
															  .box-time			{
															  		   position:absolute;
																	   right:0;
															  }
															  &:last-child      {
																	margin-top:3px;
																	height:6px;
																	background:#DDDDDD;
																	border-radius:3px;
																	.box-radius      {
																			   position:absolute;
																			   width:0;
																			   height:6px;
																			   border-radius:10px;
																			   display:inline-block;
																			   background:#3D79FE;
																			 
																	}
															  }
													  }
										  }
								   }
					 }
					
		  }
}



</style>